export default "__VITE_ASSET__B_fl8caR__"